import { addToGlobalThisRet } from "@plugins";

class OfferTimer {
    constructor(element) {
        this.element = element;
        this.targetDate = "";
        this.currentDate = "";
        this.gap = null;
        this.timerId = "";
        this.timer = [
            {
                elem: this.element.querySelector(".js-timer-minuts"),
                formula: () => Math.floor(this.gap / 1000 / 60) % 60,
            },
            {
                elem: this.element.querySelector(".js-timer-seconds"),
                formula: () => Math.floor(this.gap / 1000) % 60,
            },
        ];
        this._init();
    }

    _init() {
        this._getDateGap();

        this._counts();
        this.element.classList.add("initialized");
        this.timerId = setInterval(() => this._counts(), 1000);
    }

    _getDateGap() {
        const dataOfferTimerEndValue = this.element.dataset.timerEnd;
        this.endDate = new Date(dataOfferTimerEndValue);

        const dataOfferTimerBeginValue = this.element.dataset.timerBegin;
        this.beginDate = new Date(dataOfferTimerBeginValue);

        this.gap = this.endDate.getTime() - this.beginDate.getTime();
    }

    _counts() {
        if (this.gap < 1000) {
            this.element.querySelector(".js-timer-block").innerText =
                "Предложение больше не действует";
            this.element.classList.add("ended");
            document.querySelector(".js-buy-cheaper-btn").classList.add("disabled");
            clearInterval(this.timerId);
        } else {
            this.gap -= 1000;

            for (const item of this.timer) {
                item.elem.innerText = item.formula();
            }
        }
    }
}

function initOfferTimer() {
    const timer = document.querySelector(".js-buy-cheaper-popup-timer");

    if (timer) {
        new OfferTimer(timer);
    }
}

addToGlobalThisRet(initOfferTimer, "initOfferTimer");
